import { HttpErrorResponse } from '@angular/common/http';
import { ApolloLink, FetchResult, Operation } from '@apollo/client/core';
import { Observable } from '@apollo/client/utilities';

export let BYPASS_ERROR_HANDLER_FOR_GRAPHQL_ERROR_CODES: number[] = [];

export class BypassErrorLink extends ApolloLink {
    constructor(private statusCodesToBypass: number[]) {
        super();
        BYPASS_ERROR_HANDLER_FOR_GRAPHQL_ERROR_CODES = this.statusCodesToBypass;
    }

    override request(operation: Operation, forward: (op: Operation) => Observable<FetchResult>): Observable<FetchResult> {
        return new Observable<FetchResult>((observer) => {
            const subscription = forward(operation).subscribe({
                next: (data) => {
                    return observer.next(data);
                },
                error: (error: any) => {
                    this.shouldBypassError(error)
                        ? observer.next({
                              data: error.error.data,
                              errors: error.error,
                              extensions: { statusCode: error.status },
                          })
                        : observer.error(error);
                },
                complete: () => {
                    BYPASS_ERROR_HANDLER_FOR_GRAPHQL_ERROR_CODES = [];
                    return observer.complete();
                },
            });

            return () => {
                if (subscription) subscription.unsubscribe();
            };
        });
    }

    shouldBypassError(error: HttpErrorResponse): boolean {
        return BYPASS_ERROR_HANDLER_FOR_GRAPHQL_ERROR_CODES.includes(error.status);
    }
}
